<div class="ziro-admin-page-content">
  <ziro-loading-block [hidden]="!isLoading"></ziro-loading-block>

  <div class="col-md-10 offset-md-1 pb-2" [hidden]="isLoading">
    <ziro-breadcrumbs></ziro-breadcrumbs>

    @if (!isLoading) {
      <ziro-admin-ldap-management-settings
        [ldapConfiguration]="ldapConfiguration"
        [isSaved]="isSaved"
        [isProxyServerEnabled]="isProxyServerEnabled"
      ></ziro-admin-ldap-management-settings>
    }
    @if (!isLoading) {
      <ziro-admin-ldap-management-permissions
        [ldapPermissionGroup]="ldapPermissionGroup"
        [isSaved]="isSaved"
        [isProxyServerEnabled]="isProxyServerEnabled"
      ></ziro-admin-ldap-management-permissions>
    }
  </div>
</div>
